/* eslint-disable no-param-reassign */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/named */
/* eslint-disable prefer-template */
/* eslint-disable one-var */
/* eslint-disable radix */
/* eslint-disable no-else-return */
/* eslint-disable no-shadow */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-var */
/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-const */
/* eslint-disable dot-notation */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState, useReducer } from 'react'
import { connect, useDispatch } from 'react-redux'
import FileBase64 from 'react-file-base64';
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";

import PropTypes, { object } from 'prop-types';
import clsx from 'clsx'
import moment from 'moment';
// import {  } from "@material-ui/core";
import { Modal, Dialog, DialogTitle, DialogContent, DialogActions, Box, TextField, Grid, FormGroup, IconButton } from '@material-ui/core'; // Remove the unused imports for CHG0073013
import TablePagination from "@mui/material/TablePagination";
import { useHistory } from 'react-router-dom';
import InputAdornment from '@material-ui/core/InputAdornment';
// import { SearchOutlined } from '@material-ui/icons';
import DeleteIcon from '@mui/icons-material/Delete';


import { MdReplay } from 'react-icons/md';
import styles from './ReportNoManager.module.css'
import { CustomDatePicker, CustomFormGroup, CustomSelect, ValidatingTextField } from '../FormComponents'
import { DATE_FORMAT, API_RESOURCE_URLS, DISPLAY_MESSAGES, MESSAGE_TYPE, RESOURCE_TYPE, USER_OPERATIONS, Regex } from '../../constants'
import { API } from '../../apis/api'
import TextIcon from './TextIcon'
import { buildErrorMessage } from '../../apis/calls'
import Table from '../Table/Table';
import { usePopupManager } from '../../providers/PopupManager/PopupManager';
import { AuthChecker, Button } from '../../atomicComponents';
import { withAllowedOperationsProvider } from '../../hocs'
import { setToast, setPORow, poSearch, fetchChassis, setChassisData, setAllDetails, getInvoice } from '../../redux/actions/productsActions';
import Truckloading from "../CvLoader/Cvloader";
import { setLogin } from '../../redux/features/auth/actions';
import ReportTable from '../ReportTableComponent/ReportTable';



const initialState = {
  plant: null,
  part: null,
  aqCommodity: null,
  purchaseCommodity: null,
  supplierCode: null,
  supplierDetails: null,
  supplierName: '',
  supplierLocation: '',
  selectedProject: null,
  selectedPO: null,
  inputFields: {
    purchaseBuyerName: '',
    suppRepresentativeName: '',
    suppRepresentativeContact: '',
    suppRepresentativeEmail: ''
  },
  errors: {},
}
const reducer = (state, action) => {
  switch (action.type) {
    case 'update':
      return {
        ...state,
        [action.field]: action.value
      }
    case 'reset':
      return {
        ...state,
        ...initialState
      }
    default:
      return state
  }
}

function ReportNoManager({ redirectToProcessPage, product, counter, baseUrl, auth }) {
  const ROW_HEIGHT = 38;
  const [rowsData, setRowsData] = useState({
    loading: false,
    data: [],
    filteredData: [],
  });
  const [poData, setPOData] = useState({
    loading: false,
    data: [],
    filteredData: [],
    last: false,
    number: 0
  });
  const [state, dispatch] = useReducer(reducer, initialState);
  const { showInternalError } = usePopupManager();
  const { showPopup } = usePopupManager();
  const dispatchNew= useDispatch();
  const history = useHistory();



  const { damage, invoice, plant, part, aqCommodity, purchaseCommodity, supplierCode, supplierDetails, supplierName,
    supplierLocation, selectedProject, selectedPO, inputFields, errors } = state;


  const [suppliers, getSuppliers] = useState({ loading: false, data: [] });
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [confirmModalFlag, setConfirmModal] = useState(false);
  const [confirmModalFlag2, setConfirmModal2] = useState(false);
  const [deleteParam, handleDeleteParam] = useState();
  const [deleteParam2, handleDeleteParam2] = useState();
  const [resetAllVisitedFields, setResetAllVisitedFields] = useState(false);
  const [highlightMandatoryFields, setHighlightMandatoryFields] = useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [page, setPage] = React.useState(0);
  const [loadings, setLoadings] = React.useState(false);
  const [viewDisplay, setViewDisplay] = useState(false);
  const [toggle, setToggle] = React.useState(false);
  const [loader, setLoader] = React.useState(true);
  const [hover, setHover] = useState({ isHover: false, name: null });
  const [bodyBuilderOption, setBdybuilderOption] = useState([]);
  const [chassisOption, setChassisData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [asnCount, setAsnCount] = useState(0);
  const [tableArray, setTableArray] = useState([]);
  const [allTableData,setAllTableData]=useState([])
  const [companyCodeOption, setCompanyCode] = useState([]);

  const HEIGHT = '250px';
  const FILENAME = 'NO_Manager_Report';

  const [myState, setState] = React.useState(
    {
      poNo: "",
      stmNo: "",
      chassisNo: null,
      toDate: null,
      fromDate: null,
      bodyBuilder: null,
      checkFlag: false

    });

  const setCount = count => {
    setAsnCount(count);
  };
  const handleDate = (date, name) => {
    //  let newvalue = convert(date);
    if (date == null) {
      setState((prevData) => ({ ...prevData, [name]: null }));
      return;

    }
    let newDate = date.format(DATE_FORMAT.ISO)
    setState((prevData) => ({ ...prevData, [name]: date }));

  }

  const resetError = (name) => {
    if (name == "chassisNo") {
      strflag();
      //    setState((prevData) => ({ ...prevData, chassisNoFlagStr: false }));
    }
  }

  useEffect(() => {
    setTableArray(allTableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage))
  }, [rowsPerPage, page])

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
  };

const strflag = () => {
    var regexp = new RegExp(/^[a-zA-Z0-9 ]+$/);
    let str = myState.chassisNo;
    if (myState.chassisNo == "") {
      return
    }

    if (regexp.test(str)) {


      setState((prevData) => ({ ...prevData, chassisNoFlagStr: false }))
      return true
    }
    else {
      setState((prevData) => ({ ...prevData, chassisNoFlagStr: true }))
      return false

    }

  }
  const convert2 = (str) => {
    if (str == null) {
      return '';
    } else {


      const date = new Date(str);
      const mnth = (`0${date.getMonth() + 1}`).slice(-2);
      const day = (`0${date.getDate()}`).slice(-2);
       return [date.getFullYear(), mnth, day].join("-"); //  2022-03-29 

      // return [mnth, day, date.getFullYear()].join("-"); // 03/08/2022
    }
  }

  const showError = (msg) => {
    showPopup({
      type: MESSAGE_TYPE.FAILURE,
      contextText: MESSAGE_TYPE.FAILURE,
      info: msg,
    });
  }

 
  const handleSubmit = async () => {
    setLoadings(true);
    setState((prevState) => ({ ...prevState, tableFlag: true }));
    setViewDisplay(true);
    setRowsPerPage(10)
   
    let fromDate = convert2(myState.fromDate);
    let toDate = convert2(myState.toDate);

    if (fromDate == "" || toDate == "") {
      setLoadings(false);
      setAllTableData([])
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please enter a date",
      });
      return
  
    }
    const isSameOrAfter = moment(fromDate).isAfter(toDate);
   
    if (isSameOrAfter) {
       setLoadings(false)
       showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "End Date Should Be Greater Than  Or Equal To Start Date ",
      });
      setTableArray([])
      setAllTableData([])
      }
    else{
  let apiFormatedData = {
    FRM_DATE: fromDate,
    TO_DATE: toDate,
  };
  console.log(apiFormatedData,'apiFormatedData');
  var apiFormatedDataJson = JSON.stringify(apiFormatedData);
  let headerss = new Headers();;
  headerss.append("Content-Type", "application/json");
  fetch(`${baseUrl}reports/NM_Export`, {
    method: "POST",
    headers: headerss,
    credentials:"include",
    body: apiFormatedDataJson,
  })
    .then((response) => {
     
      dispatchNew(setLogin({...auth, recentStatus: response.status}))
      let responsecode=response.status
      if(responsecode===403){
       setLoadings(false);
      }

      return response.json();
      })
    .then((responseJson) => {
      if (responseJson.msg=="Success"  && responseJson.data.length != 0) {
        setLoadings(false);
        const finalList = [];
        responseJson.data.map((row, index) => {
          finalList.push({
            id: index,
            ...row,
          });
        });
        setAllTableData(finalList)
        setTableArray(finalList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage));
      
        setState((prevState) => ({ ...prevState, tableFlag: true }));
      }
      else if(responseJson.msg=="Success" && responseJson.data.length == 0) {
        setAllTableData([])
        setLoadings(false);
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: "No Records Found",
      })}
      else if(responseJson && responseJson.msg=="Fail")  {
        setAllTableData([])
        setLoadings(false);
        showPopup({
          type: MESSAGE_TYPE.FAILURE,
          contextText: MESSAGE_TYPE.FAILURE,
          info: responseJson.data,
      })
      }
    
    }).catch((error) => {
      setAllTableData([])
      setLoadings(false);
      if (error.response) {
        showPopup({
                type: MESSAGE_TYPE.FAILURE,
                contextText: MESSAGE_TYPE.FAILURE,
                info: "Oops! Something went wrong. Please try again later. Please try again later",
            })
      }
      else {
        showPopup({
              type: MESSAGE_TYPE.INFORMATION,
              contextText: MESSAGE_TYPE.INFORMATION,
              info: "There might be Network issue, please try after some time",
          })
      }
    });
    };
  }


  const onHover = (name) => {
    setHover({ isHover: true, name: name });
  };

  const onLeave = () => {
    setHover({ isHover: false, name: null });
  };

  const BG_COLOR = '#fffef8';
  const [backgroundColors, setBackgroundColors] = useState({
    processInfoBg: true,
    supplierInfoBg: false,
    poInfoBg: false,
    projectsInfoBg: false
  });
  const { processInfoBg, supplierInfoBg, poInfoBg, projectsInfoBg } = backgroundColors;

  const changeBackgroundColor = (field) =>
    setBackgroundColors(prev => {
      const newBackgroundColors = {};
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(prev)) {
        if (key === field)
          newBackgroundColors[key] = true;
        else
          newBackgroundColors[key] = false;
      }
      return newBackgroundColors
    })


  const loadSupliers = async () => loadData(getSuppliers, API_RESOURCE_URLS.getSuppliers(),
    { plantCode: plant ? plant.value : null, partNumber: part ? part.value : null });
  const handleOpen = () => {
    window.location.reload()
    // setIsPopupOpen(true);
    // setTableArray([])
    // setAllTableData([])
  }
 
  const handleClose = () => setIsPopupOpen(false);
  const handleOpen1 = () => {
    setConfirmModal(true);


  };
  const handleOpen2 = () => {
    setConfirmModal2(true);


  };
  const handleClose2 = () => setConfirmModal2(false);
  const resetFields = () => {
    if(myState.checkFlag==true){
      setState((prevData) => ({
        ...prevData, 
        chassisNo: null,
        toDate: null,
        fromDate: null,
      }));
    } else {
      setState((prevData) => ({
        ...prevData, 
        chassisNo: null,
        toDate: null,
        fromDate: null,
        bodyBuilder: null,
      }));
    }
 
    setTableData([])
    setHighlightMandatoryFields(false)

  }

  const processProjectList = projectList => {
    let processedProjectList = projectList.map(({ ...project }) => {
      const allPlants = project.plants.map(item => item.name);
      const allVehicleLines = project.vehicleLines;
      const projectCreationDate = moment(project.createdAt).format("DD/MM/YYYY");
      return {
        id: project.id,
        ...project,
        allPlants,
        allVehicleLines,
        projectCreationDate
      }
    });
    const allPlantsList = [];
    const allVehicleLineList = [];
    processedProjectList.forEach(({ allPlants, vehicleLines }) => {
      allPlantsList.push(...allPlants);
      allVehicleLineList.push(...vehicleLines);
    });

    processedProjectList = processedProjectList.map(({ ...project }) => (
      {
        ...project,
        allPlants: [...new Set(allPlantsList)],
        allVehicleLines: [...new Set(allVehicleLineList)],
      }
    ));
    return processedProjectList;
  }
  const loadAllProjects = async () => {
    try {
      setRowsData(prev => ({
        ...prev,
        loading: true,
      }));

      const response = await API.get(
        API_RESOURCE_URLS.PROJECTS
      );

      const { data: projectList } = response;
      const processedProjectList = processProjectList(projectList);

      setRowsData({
        data: processedProjectList,
        filteredData: processedProjectList,
        loading: false,
      });
    } catch (error) {
      showInternalError(error);
      console.error(buildErrorMessage(error));
      setRowsData({
        data: [],
        filteredData: [],
        loading: false,
      });
    }
  };
  const baseDefaultColumns = [
    {
      width: 110,
      title: 'Pers No',
      field: 'pers_no',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 140,
      title: 'BC Name',
      field: 'complete_name',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 100,
      title: 'BC NO ',
      field: 'bc_number',
      enableSearch: true,
      enableFilter: true,
    }, 


    { 
      width: 190,
      title: 'BC Description',
      field: 'bc_name',
      enableSearch: true,
      enableFilter: true,
    },
    { 
      width: 100,
      title: 'Booking Month',
      field: 'book_month',
      enableSearch: true,
      enableFilter: true,
    },

    { 
      width: 160,
      title: 'Booking Status',
      field: 'book_status',
      enableSearch: true,
      enableFilter: true,
    },
    { 
      width: 100,
      title: 'Approved Month',
      field: 'approval_month',
      enableSearch: true,
      enableFilter: true,
    },
    { 
      width: 120,
      title: 'Approved By',
      field: 'approved_by',
      enableSearch: true,
      enableFilter: true,
    },

    { 
      width: 90,
      title: 'Sum of Hours',
      field: 'total_hours',
      enableSearch: true,
      enableFilter: true,
    },



  ];
  const processPoList = poList => {
    const processedPoList = poList.map(({ ...po }) => {
      const plantName = po.plant.name;
      const partDesc = po.part.description;
      const id = po.number;
      const processCreationDate = moment(po.createdAt).format("DD/MM/YYYY");
      return {
        ...po,
        id,
        plantName,
        partDesc,
        processCreationDate
      }
    });
    return processedPoList;
  }

  const loadPO = async () => {
    try {
      setPOData(prev => ({
        ...prev,
        loading: true,
      }));

      const response = await API.get(
        API_RESOURCE_URLS.PURCHASE_ORDER,
        {
          params:
          {
            supplierId: supplierDetails ? supplierDetails.id : null,
            partNumber: part ? part.value : null,
            plantCode: plant ? plant.value : null,
            page: poData.number,
          }
        }
      );
      const processedPoList = processPoList(response.data.content);

      setPOData(prev => ({
        ...prev,
        data: [...prev.data, ...processedPoList],
        filteredData: [...prev.filteredData, ...processedPoList],
        loading: false,
        last: response.data.last
      })
      );

    } catch (error) {
      showInternalError(error);
      console.error(buildErrorMessage(error));
      setPOData({
        number: 0,
        data: [],
        filteredData: [],
        loading: false,
        last: false
      });
    }
  };

  const renderOther = () => (
    <div
      className={styles.formGroup}
      // style={{ backgroundColor: processInfoBg ? BG_COLOR : null }}
      onClick={() => changeBackgroundColor('processInfoBg')}
    >


      {/* <Grid
        container
        spacing={1}

        style={{ display: 'flex', justifyContent: "left" , marginTop: "0px"}}
        columns={12}
      >
         <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>STM No</label>
            </div>
            <div className={styles.formDiv}>

              <ValidatingTextField
                variant="outlined"
                size="small"
                value={myState.stmNo}
                onChange={onChangeHandler}

                name="stmNo"
                inputProps={{
                  "data-testid": "remark-input",
                }}
                style={{ width: "100%" }}

              />
            </div>
          </div>
        </Grid>
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>PO No</label>
            </div>
            <div className={styles.formDiv}>

              <ValidatingTextField
                variant="outlined"
                size="small"
                value={myState.poNo}
                onChange={onChangeHandler}

                name="poNo"
                inputProps={{
                  "data-testid": "remark-input",
                }}
                style={{ width: "100%" }}

              />
            </div>
          </div>
        </Grid> 
 
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>VC No</label>
            </div>
            <div className={styles.formDiv}>

              <ValidatingTextField
                variant="outlined"
                size="small"
                value={myState.materialNo}
                onChange={onChangeHandler}

                mame="materialNo"
                inputProps={{
                  "data-testid": "remark-input",
                }}
                style={{ width: "100%" }}

              />
            </div>
          </div>
        </Grid>
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>Target Date</label>
            </div>
            <div className={styles.formDiv}>

              <ValidatingTextField
                variant="outlined"
                size="small"
                isDisabled={true}
                value={myState.completeDate}
                inputProps={{
                  "data-testid": "remark-input",
                }}
                style={{ width: "100%" }}

              />
            </div>
          </div>
        </Grid> 

      </Grid> */}
      <Grid
        container
        spacing={1}

        style={{ display: 'flex', justifyContent: "left", marginTop: "10px" }}
        columns={12}
        className={styles.myGrid}
      >
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>From Date</label>
            </div>
            <div className={styles.formDiv}>
              <CustomDatePicker
                clearable
                // markIfUnselected={highlightMandatoryFields}
                autoOk
                inputVariant="outlined"
                value={myState.fromDate}
                onChange={(e) => { handleDate(e, 'fromDate') }}
                inputProps={{
                  className: clsx(styles.select, styles.dateInput),

                }}
                emptyLabel="DD-MM-YYYY"
                format="DD-MM-YYYY"
                data-testid="date-picker-div-1"
                style={{ width: "100%" }}

              />
            </div>
          </div>
          {myState.handoverDateFlag &&
            // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
            <div style={{ marginLeft: "35px" }} className={styles.error}>Inserted On is mandatory field</div>

          }

        </Grid>

        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>To Date</label>
            </div>
            <div className={styles.formDiv}>

              <CustomDatePicker
                clearable
                autoOk
                inputVariant="outlined"
                value={myState.toDate}
                onChange={(e) => {


                  handleDate(e, 'toDate')
                }}
                inputProps={{
                  className: clsx(styles.select, styles.dateInput),

                }}
                emptyLabel="DD-MM-YYYY"
                // defaultDate={moment().format(DATE_FORMAT.DD_MM_YYYY)}
                // minDate={!isEditable? null: getMinimumDateForPicker(index, milestones)}
                format="DD-MM-YYYY"
                data-testid="date-picker-div-1"
                style={{ width: "100%" }}
                // maxDate={moment().toDate()}
                // maxDate={moment().toDate()}
              />
            </div>
          </div>
          {myState.handoverDateFlag &&
            // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
            <div style={{ marginLeft: "35px" }} className={styles.error}>Inserted On is mandatory field</div>

          }

        </Grid>
        <Grid item md={2} lg={2}>
          <div className={styles.rowDiv}>
          
            <div className={styles.formDiv}>
       
            <Button
                  className={clsx(
                    styles.actionButton,
                    styles.primaryActionButton,
                  )}
                  variant="primary"
                  onClick={() => handleSubmit()}
                  data-testid="confirm-action"
                >
                  Search
                </Button>
                <Button
          className={clsx(styles.actionButton, styles.resetButton)}
          variant="tertiary"
          onClick={handleOpen}
          style={{marginLeft: "10px"}}
        >
          CANCEL
        </Button>
            </div>
          </div> 
        </Grid>
      </Grid>
    </div>
  )
  const newKeySequence = [
     'id',
     'pers_no',
     'complete_name',
     'bc_number',
     'bc_name',
     'book_month',
     'book_status',
     'approval_month',
     'approved_by',
     'total_hours',
  ];
  function changeKeySequence(data, keySequence) {
    console.log(data);
    return data.map((dict) => {
      const newDict = {};
      keySequence.forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(dict, key)) {
          newDict[key] = dict[key];
        }
      });
      return newDict;
    });
  }

  function downloadExcel(data) {
    const modifiedList = changeKeySequence(data, newKeySequence);
    console.log(modifiedList);
    const columnsKeys = {
      'id': 'Id',
     'pers_no':'Pers No',
     'complete_name':'BC Name',
     'bc_number':'BC NO',
     'bc_name':'BC Description',
     'book_month':'Booking Month',
    'book_status':'Booking Status',
    'approval_month':'Approved Month',
    'approved_by':'Approved By',
    'total_hours':'Sum of Hours',
    }
    modifiedList.forEach((item, index) => {item.id = index + 1;});
    const updateExportData = modifiedList.map(dict => Object.keys(dict).reduce((acc, key) => {
      acc[columnsKeys[key] || key] = dict[key];
      return acc;
    }, {}));
    const sheet = XLSX.utils.json_to_sheet(updateExportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, sheet, 'Sheet1');
    XLSX.writeFile(workbook, 'NoManagerReportDetails.xlsx');
  }
  
  const renderReport = () => (
    <div
      className={styles.formGroup}>
        <Grid
            container
            spacing={1}
            // className={styles.myGrid}
            style={{ marginTop: "10px" }}
            columns={12}
          >
             {/* <Grid item md={2} lg={2} xs={2} sm={2}>
              <div className={styles.rowDiv}>
                <div className={clsx(styles.lableDiv2)}>
                  <label>Report Details:</label>
                </div>
              </div>
            </Grid> */}
      <Grid item md={12} lg={12} xs={12} sm={10}>
      <div className={styles.formDiv}>
      <div
      //  className={styles.customeTable}
        className={styles.col2} style={{
          width: "100%",
          height: "100%",
          marginTop: "10px"
        }}
      >
        <ReportTable columns={baseDefaultColumns} data={allTableData} height={HEIGHT} fileName={FILENAME} />
       
          {/* <>
        <Table
          viewDisplay={viewDisplay}
          columns={baseDefaultColumns}
          defaultColumns={baseDefaultColumns}
          rowHeight={ROW_HEIGHT}
              rows={tableArray}
              secondaryActions={[
                {
                  name: "Export",
                  getFilteredData: true,
                  authOperation: "create-project",
                  shouldEnable: (tableArray) => tableArray,
                  actionFn: filteredData => {
                    // goTo(selected),
                    // handleExport(filteredData);
                    // ExportFile(filteredData)
                    downloadExcel(filteredData)
                  },
                },
              ]}
          setAsnCount={setCount}
          isDataLoading={false}
          actionButtons
        //    onRowSelect={(e) => { console.log('onRowSelect call') }}
        />
        <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={allTableData?.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                
          />
           </> */}
      </div>
      </div>
      </Grid>
      </Grid>

    </div>)



  const getSelectedFields = () => ({
    projectId: selectedProject,
    poNumber: selectedPO,
    commodityGroupId: purchaseCommodity && purchaseCommodity.value,
    aqCommodityGroupId: aqCommodity && aqCommodity.value,
    purchaseBuyerName: inputFields?.purchaseBuyerName,
    kamContactDetails: {
      // id: inputFields,
      name: inputFields?.suppRepresentativeName,
      contactNumber: inputFields?.suppRepresentativeContact,
      emailId: inputFields?.suppRepresentativeEmail
    }
  });

  const validateFields = (fields) => {
    const requiredFields = { ...fields, ...fields.kamContactDetails }
    const hasMissingRequiredFields = Object.values(requiredFields).some(
      (field) => !field
    );

    const hasError = Object.values(errors).some((err) => err);

    if (hasMissingRequiredFields || hasError) {
      return false;
    }
    return true;
  };

  const runPreSubmissionChecks = () => {
    const selectedFields = getSelectedFields();
    const areFieldsValid = validateFields(selectedFields);

    if (!areFieldsValid) {
      setHighlightMandatoryFields(true);
      // return false;
      return true;
    }
    return true;
  };
  const resetAllInputs = () => {
    const inputs = {
      purchaseBuyerName: '',
      suppRepresentativeName: '',
      suppRepresentativeContact: '',
      suppRepresentativeEmail: ''
    }
    dispatch({ type: 'update', field: 'inputFields', value: inputs });
    dispatch({ type: 'update', field: 'errors', value: {} });
  }

  const resetState = () => {
    dispatch({ type: 'reset' });
    resetAllInputs();
    resetTableData();
    setHighlightMandatoryFields(null);
    setResetAllVisitedFields(false);
    changeBackgroundColor('processInfoBg');
  }



  useEffect(() => {
    if (resetAllVisitedFields)
      resetState();
  }, [resetAllVisitedFields])



  return (
    <>
      <div className={clsx(styles.scrollContainer, styles.scrollBar, styles.formContainer)}>
        <CustomFormGroup header='No Manager Report' body={renderOther()} />
{myState.tableFlag && allTableData.length > 0 && (
  <>
{renderReport()}

            

</>
        )}
        {
  loadings ? (
    <div style={{textAlign:"center",display:"flex",justifyContent:"center",marginTop:"40px"}}>
         <Truckloading />
    </div>):""
}
      </div>
       <ResetModal
        isPopupOpen={isPopupOpen}
        handleClose={handleClose}
        resetFields={resetFields}
      />

      <ResetModal2
        a={confirmModalFlag2}
        handleCase={handleClose2}
        onDelete={() => onDeleteRow2(deleteParam2)}
      />


    </>
  )
}
function ResetModal2({ a, handleCase, onDelete }) {
  return (
    <Dialog
      open={a}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup1"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <DeleteIcon style={{ height: '18px', width: '18px' }} />
            <span className={styles.txt}>Are you sure ?</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>
            Do you want to delete ?
          </span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(
              styles.actionButton,
              styles.transparentButton
            )}
            onClick={handleCase}
          >Cancel</Button>
          <Button
            className={clsx(
              styles.actionButton,
              styles.primaryActionButton,
            )}
            variant="primary"
            onClick={onDelete}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  )
}
function ResetModal1({ a, handleCase, onDelete }) {
  return (
    <Dialog
      open={a}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup1"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <DeleteIcon style={{ height: '18px', width: '18px' }} />
            <span className={styles.txt}>Are you sure ?</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>
            Do you want to delete ?
          </span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(
              styles.actionButton,
              styles.transparentButton
            )}
            onClick={handleCase}
          >Cancel</Button>
          <Button
            className={clsx(
              styles.actionButton,
              styles.primaryActionButton,
            )}
            variant="primary"
            onClick={onDelete}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  )
}

function ResetModal({ isPopupOpen, handleClose, resetFields }) {
  return (
    <Dialog
      open={isPopupOpen}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <MdReplay style={{ height: '18px', width: '18px' }} />
            <span className={styles.txt}>Reset</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>
            Are you sure you want to reset the filters?
          </span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(
              styles.actionButton,
              styles.transparentButton
            )}
            onClick={handleClose}
          >Cancel</Button>
          <Button
            className={clsx(
              styles.actionButton,
              styles.primaryActionButton,
            )}
            variant="primary"
            onClick={(e) => {
              e.preventDefault();
              handleClose()
              resetFields()
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  )
}

ReportNoManager.propTypes = {
  redirectToProcessPage: PropTypes.func
}

ResetModal.propTypes = {
  isPopupOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  resetFields: PropTypes.func.isRequired
}
ResetModal1.propTypes = {
  a: PropTypes.bool.isRequired,
  handleCase: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
}
ResetModal2.propTypes = {
  a: PropTypes.bool.isRequired,
  handleCase: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
  product: state.product,
  counter: state.counter.value,
  baseUrl: state.counter.baseUrl,
  auth: state.auth
});
const mapDispatchToProps = (dispatch) => ({

  fetchChassis: (chassisParam) => dispatch(fetchChassis(chassisParam)),
  getInvoice: (chassisParam) => dispatch(getInvoice(chassisParam)),
});
ReportNoManager.propTypes = {
  counter: PropTypes.number,
  baseUrl: PropTypes.string,
  product: PropTypes.object,
  auth: PropTypes.object,
};
const App = connect(mapStateToProps, mapDispatchToProps)(ReportNoManager);


export default withAllowedOperationsProvider(
  App,
  RESOURCE_TYPE.PPAP
);